import {useEffect} from 'react'
import {useFloatingNodeId, useFloatingParentNodeId, useFloatingTree} from '@floating-ui/react'

export const useCloseDropdownOnItemClick = ({isOpen, setIsOpen}) => {
	const dropdownTree = useFloatingTree()
	const dropdownItemId = useFloatingNodeId()
	const dropdownId = useFloatingParentNodeId()

	// Close all dropdowns when an item gets clicked anywhere in the tree.
	useEffect(() => {
		if (!dropdownTree) return

		const handleTreeClick = () => {
			setIsOpen(false)
		}

		const onSubMenuOpen = event => {
			if (event.dropdownItemId !== dropdownItemId && event.dropdownId === dropdownId) {
				setIsOpen(false)
			}
		}

		dropdownTree.events.on('click', handleTreeClick)
		dropdownTree.events.on('menuopen', onSubMenuOpen)

		return () => {
			dropdownTree.events.off('click', handleTreeClick)
			dropdownTree.events.off('menuopen', onSubMenuOpen)
		}
	}, [dropdownTree, dropdownItemId, dropdownId])

	useEffect(() => {
		if (isOpen && dropdownTree) {
			dropdownTree.events.emit('menuopen', {dropdownId, dropdownItemId})
		}
	}, [dropdownTree, isOpen, dropdownItemId, dropdownId])
}
